import { updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config';
import { registerStatus } from '../../../../constants/enum';

/**
 * resultレコードを削除（論理削除）
 */
export const deleteResult = async (id: string): Promise<void> => {
  const resultDocRef = doc(db, 'results', id);
  await updateDoc(resultDocRef, {
    status: registerStatus.deleted,
    deleted_at: serverTimestamp(),
  });
};
